import { PkIdentifier } from '@uefadigital/panenka-react';
import { memo, useMemo } from 'react';

import { handleHeaderItemClick } from '../../utils';

import Image from '@shared/Image';
import type { MenuItem } from '@shared-types/menu.types';
import { imgBaseUrl } from '@utilities/WindowContext';
const CompetitionIdentifier = ({ item }: { item: MenuItem }) => {
  const compCode = item.customProperties?.compCode ?? item.id;
  const logo = `${imgBaseUrl}/imgml/uefacom/elements/logos/competitions/dark/${compCode}` + '.svg';

  const handleClick = useMemo(() => handleHeaderItemClick(item), [item]);

  return (
    <a href={item.href} target={item.target} aria-label={item.text} onClick={handleClick} onAuxClick={handleClick}>
      <PkIdentifier alignment='center' type='vertical'>
        <Image slot='prefix' src={logo} width={43} height={43} />
        <span className='pk-text--text-02 pk-text--wrap pk-font--base-regular' slot='primary'>
          {item.text}
        </span>
      </PkIdentifier>
    </a>
  );
};

export default memo(CompetitionIdentifier);
